export default __webpack_public_path__ + "static/media/not_found_image.dc4e2324.svg";